<template>
  <router-view :key="$route.path" />
</template>

<script>
export default {
  name: "Index"
};
</script>

<style scoped></style>
